export const DEFAULT_GAUDI3_BACKEND = 'gaudi3_pcie';

const PER_SHARD_VARIANT_PATTERN = /(?:k|x|shard|group|bridge)[_-]?\d+/i;

export function canonicalizeThroughputBackend(rawBackend: unknown): string | null {
  if (typeof rawBackend !== 'string') {
    return DEFAULT_GAUDI3_BACKEND;
  }

  const trimmed = rawBackend.trim();
  if (!trimmed) {
    return DEFAULT_GAUDI3_BACKEND;
  }

  const normalized = trimmed.toLowerCase();
  if (normalized.startsWith('gaudi3')) {
    const variant = normalized.replace('pcie', '');
    if (PER_SHARD_VARIANT_PATTERN.test(variant)) {
      // Shard-level rows should be ignored so the engine can derive per-shard throughput.
      return null;
    }
    return DEFAULT_GAUDI3_BACKEND;
  }

  return trimmed;
}

